import DapDSFormLabel from './form-label.component'

export * from './form-label.component'
export default DapDSFormLabel

DapDSFormLabel.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-form-label': DapDSFormLabel
  }
}
